import { useMountEffect } from "@react-hookz/web";
import React from "react";
import { useSdkContext } from "~/components/contexts";
import { Container } from "./styles";
export const PianoTooltipDisplay = ({
  message
}) => {
  const {
    handleTrackGA,
    rosettaInstance
  } = useSdkContext();
  useMountEffect(() => {
    var _rosettaInstance$rule;
    const {
      impressionLabel,
      impressionUserType
    } = (_rosettaInstance$rule = rosettaInstance === null || rosettaInstance === void 0 ? void 0 : rosettaInstance.rulesEngine.getOutcome("ui.tooltip")) !== null && _rosettaInstance$rule !== void 0 ? _rosettaInstance$rule : {};
    handleTrackGA({
      action: `My Account/Hint/${impressionUserType !== null && impressionUserType !== void 0 ? impressionUserType : "Subscribers"}/Impression`,
      category: "My Account",
      label: impressionLabel !== null && impressionLabel !== void 0 ? impressionLabel : ""
    });
  });
  return /*#__PURE__*/React.createElement(Container, {
    dangerouslySetInnerHTML: {
      __html: message
    },
    "data-qa": "piano-tooltip-display"
  });
};
PianoTooltipDisplay.displayName = "PianoTooltipDisplay";